import { render, staticRenderFns } from "./CustomFormGroup.vue?vue&type=template&id=572ab9c0&"
import script from "./CustomFormGroup.vue?vue&type=script&lang=js&"
export * from "./CustomFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormGroup} from 'bootstrap-vue'
    installComponents(component, {BFormGroup})
    

export default component.exports